<app-unitInfoLoader *ngIf="loaderIcon | async"></app-unitInfoLoader>
<div class="row mx-0 justify-content-between align-items-end sameWidthBtn">
  <h5 class="ssm-page-heading2 NoLeftPadding"*ngIf="!readonlyMode">Alternate & Authorized Contacts</h5>
  <button *ngIf="!readonlyMode" type="button" class="btn btn-primary" data-toggle="modal" (click)="onAddClicked()">Add</button>
</div>
<div class="row mx-0 mt-2">
  <div class="scroll_outer NoPadding">
    <div class="scroll_inner_small">
      <div class="normal_table">
        <table class="table table-striped table-hover mb-0">
          <thead>
            <tr>
              <th  class="text-center">Primary</th>
              <th class="text-center">Emergency</th>
              <th  class="text-center">First Name</th>
              <th  class="text-center">Last Name</th>
              <th class="text-center">Send Letters</th>
              <th class="text-center">Gate Access</th>
            </tr>
          </thead>
          <tbody *ngIf="checkAlternateContactLIst() == 0 || checkAlternateContactLIst() == 1">
            <tr>
              <td colspan="6" *ngIf="(!IsAlternateContactMandatory && checkAlternateContactLIst() == 0)
                       || (IsAlternateContactMandatory && isExemptAltContactMandatory)">No Record
                Found
              </td>
              <td colspan="6"
                *ngIf="IsAlternateContactMandatory && !isExemptAltContactMandatory && (checkAlternateContactLIst() == 1 || checkAlternateContactLIst() == 0)"
                style="color: red;">No Alternate Contact Record Found. Alternate Contact Is Mandatory</td>
            </tr>
          </tbody>
          <tbody *ngFor="let item of alternateContactsGridData ; let i = index">
            <tr *ngIf="!item.Deleted" (click)="readonlyMode ? gotoDetailsInReadonlyMode(item) : gotoDetails($event,item, i)" style="cursor: pointer;">
              <td [ngStyle]="{'pointer-events' : item.IsPrimaryAlternateContact ? 'none' : 'auto'}" class="text-center"><input type="checkbox"
                  [checked]="item.IsPrimaryAlternateContact"
                  [ngStyle]="{'pointer-events' : item.IsPrimaryAlternateContact ? 'none' : 'auto'}"
                  [(ngModel)]="item.IsPrimaryAlternateContact" [disabled]="readonlyMode || !item.CheckAlternateContact"
                  [ngModelOptions]="{standalone: true}" (change)="makePrimaryContactInGrid(i)" /></td>
              <td class="text-center">
                <label class="pure-material-checkbox mb-0 me-3 without-text">
                  <input type="checkbox" 
                  [checked]="item.IsEmergencyContact" 
                    [disabled]="true"
                    [(ngModel)]="item.IsEmergencyContact"
                    [ngModelOptions]="{standalone: true}"
                    (change)="checkDirty($event, item.AlternateId)">
                  <span></span>
                </label>
              </td>
              <td class="text-center">{{item.FirstName}}</td>
              <td class="text-center">{{item.LastName}}</td>
              <td class="text-center">
                <label class="pure-material-checkbox mb-0 me-3 without-text">
                  <input type="checkbox" [checked]="item.SendLetters" [(ngModel)]="item.SendLetters"
                    [ngModelOptions]="{standalone: true}" [disabled]="readonlyMode || item.CheckAlternateContact"
                    (change)="checkDirty($event, item.AlternateId)">
                  <span></span>
                </label>
              </td>
              <td class="text-center">
                <label class="pure-material-checkbox mb-0 me-3 without-text">
                  <input type="checkbox" [checked]="item.GateAccess" [(ngModel)]="item.GateAccess"
                    [ngModelOptions]="{standalone: true}" [disabled]="true"
                    (change)="checkDirty($event,item.AlternateId)">
                  <span></span>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


<!-- Start Add Alternate Contact Modal -->
<div bsModal #alternateContactPopup="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">
  <div class="modal-customsize modal-dialog modal-dialog-centered modal-lg modal-xxl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Alternate & Authorized Contacts</h5>
        <button type="button" class="close" (click)="cancelACForm(template1)" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body alternate_contact_form">
        <div>
          <app-call-script [section]="section"></app-call-script>
        </div>
        <form [formGroup]="alternateContactForm">
          <div class="d-inline-flex mb-2">
            <div class="me-4" style="margin-right: 10px;"><input type="radio" name="CheckAlternateContact" (click)="!readonlyMode && alternateOrAuthClick(true)"
                formControlName="CheckAlternateContact" value="true" class="me-2">Alternate Contact</div>
            <div class="me-2"><input type="radio" name="CheckAlternateContact" (click)="!readonlyMode && alternateOrAuthClick(false)"
                formControlName="CheckAlternateContact" value="false" class="me-2">Authorized User</div>
          </div>
          <div class="card p-3 bg-light">
            <div class="row">
              <div class="form-group col-md-4 ">
                <label>First Name
                  <span isMandatory [fieldName]="'ACFirstName'" [RequiredList]="alternateContactReqList"
                    class="required">*</span>
                </label>
                <input type="text" class="form-control" formControlName="ACFirstName" maxlength="35"
                  appHighlightCallScriptFields [fieldName]="'ACFirstName'"
                  [linkedFieldsList]="altContactCallScriptFields" [readonly]="readonlyMode"/>
                <div class="alert alert-danger"
                  *ngIf="alternateContactForm.get('ACFirstName').errors  && (alternateContactForm.get('ACFirstName').dirty || alternateContactForm.get('ACFirstName').touched)">
                  <span *ngIf="alternateContactForm.get('ACFirstName').errors.required">First
                    Name is required</span>
                  <span *ngIf="alternateContactForm.get('ACFirstName').errors.whitespace">
                    Invalid input </span>
                </div>
              </div>
              <div class="form-group col-md-4 ">
                <label>Middle Name
                  <span isMandatory [fieldName]="'ACMiddleName'" [RequiredList]="alternateContactReqList"
                    class="required">*</span>
                </label>
                <input type="text" class="form-control" formControlName="ACMiddleName" maxlength="35"
                  appHighlightCallScriptFields [fieldName]="'ACMiddleName'"
                  [linkedFieldsList]="altContactCallScriptFields" [readonly]="readonlyMode"/>
                <div class="alert alert-danger"
                  *ngIf="alternateContactForm.get('ACMiddleName').errors  && (alternateContactForm.get('ACMiddleName').dirty || alternateContactForm.get('ACMiddleName').touched)">
                  <span *ngIf="alternateContactForm.get('ACMiddleName').errors.required">Middle
                    Name is required</span>
                </div>
              </div>
              <div class="form-group col-md-4 ">
                <label>Last Name
                  <span isMandatory [fieldName]="'ACLastName'" [RequiredList]="alternateContactReqList"
                    class="required">*</span>
                </label>
                <input type="text" class="form-control" formControlName="ACLastName" maxlength="35"
                  appHighlightCallScriptFields [fieldName]="'ACLastName'"
                  [linkedFieldsList]="altContactCallScriptFields" [readonly]="readonlyMode"/>
                <div class="alert alert-danger"
                  *ngIf="alternateContactForm.get('ACLastName').errors  && (alternateContactForm.get('ACLastName').dirty || alternateContactForm.get('ACLastName').touched)">
                  <span *ngIf="alternateContactForm.get('ACLastName').errors.required">Last
                    Name
                    is required</span>
                  <span *ngIf="alternateContactForm.get('ACLastName').errors.whitespace">
                    Invalid input </span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-8 ">
                <label>Address
                  <span class="required" *ngIf="isRequired('ACAddress') ||  sendLettersChecked">*</span>
                </label>
                <textarea class="form-control" formControlName="ACAddress" maxlength="100" appHighlightCallScriptFields
                  [fieldName]="'ACAddress'" [linkedFieldsList]="altContactCallScriptFields" [readonly]="readonlyMode"></textarea>
                <div class="alert alert-danger"
                  *ngIf="alternateContactForm.get('ACAddress').errors  && (alternateContactForm.get('ACAddress').dirty || alternateContactForm.get('ACAddress').touched)">
                  <span *ngIf="alternateContactForm.get('ACAddress').errors.required">Address
                    is required</span>
                  <span *ngIf="alternateContactForm.get('ACAddress').errors.whitespace">
                    Invalid input </span>
                </div>
              </div>
              <div class="form-group col-md-4 ">
                <label>City
                  <span class="required" *ngIf="isRequired('ACCity') ||  sendLettersChecked">*</span>
                </label>
                <input type="text" class="form-control" formControlName="ACCity" maxlength="30"
                  appHighlightCallScriptFields [fieldName]="'ACCity'" [linkedFieldsList]="altContactCallScriptFields" [readonly]="readonlyMode"/>
                <div class="alert alert-danger"
                  *ngIf="alternateContactForm.get('ACCity').errors  && (alternateContactForm.get('ACCity').dirty || alternateContactForm.get('ACCity').touched)">
                  <span *ngIf="alternateContactForm.get('ACCity').errors.required">City
                    is required</span>
                  <span *ngIf="alternateContactForm.get('ACCity').errors.whitespace">
                    Invalid input </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4 ">
                <label>State
                  <span class="required"
                    *ngIf="!emptyStateList && (isRequired('ACState') ||  sendLettersChecked)">*</span>
                </label>
                <select class="form-select" formControlName="ACState" appHighlightCallScriptFields [fieldName]="'ACState'"
                  [linkedFieldsList]="altContactCallScriptFields"
                  (mousedown)="readonlyMode && $event.preventDefault()" (keydown)="readonlyMode && $event.preventDefault()"
                  [class.readonly-select]="readonlyMode">
                  <option *ngIf="!emptyStateList" [ngValue]="null">Select</option>
                  <option *ngIf="emptyStateList" [ngValue]="0">--</option>
                  <option *ngFor="let st of stateListAC" [ngValue]="st.Id">
                    {{st.Name}}
                  </option>
                </select>
                <div class="alert alert-danger"
                  *ngIf="alternateContactForm.get('ACState').errors && (alternateContactForm.get('ACState').dirty || alternateContactForm.get('ACState').touched)">
                  <span *ngIf="alternateContactForm.get('ACState').errors.required">State / Province
                    is required</span>

                </div>
              </div>
              <div class="form-group col-md-4 ">
                <label>Zip Code
                  <span class="required" *ngIf="isRequired('ACZipCode') ||  sendLettersChecked">*</span>
                </label>
                <input type="text" class="form-control" formControlName="ACZipCode" maxlength="15" (keypress)="validateZipInput($event)"
                  appHighlightCallScriptFields [fieldName]="'ACZipCode'"
                  [linkedFieldsList]="altContactCallScriptFields" [readonly]="readonlyMode"/>
                <div class="alert alert-danger"
                  *ngIf="alternateContactForm.get('ACZipCode').errors  && (alternateContactForm.get('ACZipCode').dirty || alternateContactForm.get('ACZipCode').touched)">
                  <span *ngIf="alternateContactForm.get('ACZipCode').errors.required">Zip / Postal Code
                    is required</span>                 
                </div>
              </div>
              <div class="form-group col-md-4 ">
                <label>Country
                  <span isMandatory [fieldName]="'ACCountry'" [RequiredList]="alternateContactReqList"
                    class="required">*</span>
                </label>
                <select class="form-select" formControlName="ACCountry"
                  (change)="onACCountryChange($event.target.value)" appHighlightCallScriptFields
                  [fieldName]="'ACCountry'" [linkedFieldsList]="altContactCallScriptFields" 
                  (mousedown)="readonlyMode && $event.preventDefault()" (keydown)="readonlyMode && $event.preventDefault()"
                  [class.readonly-select]="readonlyMode">
                  <option value="" selected>Select</option>
                  <option *ngFor="let cc of countryList" [value]="cc.Id">
                    {{cc.Name}}</option>
                </select>
                <div class="alert alert-danger"
                  *ngIf="alternateContactForm.get('ACCountry').errors && (alternateContactForm.get('ACCountry').dirty || alternateContactForm.get('ACCountry').touched)">
                  <span *ngIf="alternateContactForm.get('ACCountry').errors.required">Country is required</span>

                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 ">
                <label>Cell Phone
                  <span isMandatory [fieldName]="'ACCellPhone'" [RequiredList]="alternateContactReqList"
                    class="required">*</span>
                </label>
                <div class="form-group">
                  <div class="phone_code">
                    <select class="form-select" formControlName="ACCellDialInCode" appHighlightCallScriptFields
                      [fieldName]="'ACCellDialInCode'" [linkedFieldsList]="altContactCallScriptFields"
                      (mousedown)="readonlyMode && $event.preventDefault()" (keydown)="readonlyMode && $event.preventDefault()"
                      [class.readonly-select]="readonlyMode">
                      <option value="" selected hidden>Select</option>
                      <option *ngFor="let ct of countryList" [value]="ct.Id">
                        {{ct.DialInCode}}</option>
                    </select>
                  </div>
                  <div class="phone_numb_field me-2">
                    <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputACCellPhone"
                      formControlName="ACCellPhone" cssClass="form-control p-0" appHighlightCallScriptFields
                      [fieldName]="'ACCellPhone'" [linkedFieldsList]="altContactCallScriptFields" 
                      (mousedown)="readonlyMode && $event.preventDefault()" (keydown)="readonlyMode && $event.preventDefault()"
                       [class.readonly-select]="readonlyMode"></ejs-maskedtextbox>
                    <div class="alert alert-danger"
                      *ngIf="alternateContactForm.get('ACCellPhone').errors  && (alternateContactForm.get('ACCellPhone').dirty || alternateContactForm.get('ACCellPhone').touched)">
                      <span *ngIf="alternateContactForm.get('ACCellPhone').errors.required">Cellphone is required</span>
                      <span *ngIf="alternateContactForm.get('ACCellPhone').errors.lessThanTen">Enter 10 digit Cellphone
                        Number</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 ">
                <label>Home Phone
                  <span isMandatory [fieldName]="'ACHomePhone'" [RequiredList]="alternateContactReqList"
                    class="required">*</span>
                </label>
                <div class="form-group">
                  <div class="phone_code">
                    <select class="form-select" formControlName="ACHomeDialInCode" appHighlightCallScriptFields
                      [fieldName]="'ACHomeDialInCode'" [linkedFieldsList]="altContactCallScriptFields" 
                      (mousedown)="readonlyMode && $event.preventDefault()" (keydown)="readonlyMode && $event.preventDefault()"
                      [class.readonly-select]="readonlyMode">
                      <option value="" selected hidden>Select</option>
                      <option *ngFor="let ct of countryList" [value]="ct.Id">
                        {{ct.DialInCode}}</option>
                    </select>
                  </div>
                  <div class="homephone_numb_field">
                    <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputACHomePhone"
                      formControlName="ACHomePhone" cssClass="form-control p-0" (focus)="onStartfocus($event)"
                      appHighlightCallScriptFields [fieldName]="'ACHomePhone'"
                      [linkedFieldsList]="altContactCallScriptFields"
                      (mousedown)="readonlyMode && $event.preventDefault()" (keydown)="readonlyMode && $event.preventDefault()"
                      [class.readonly-select]="readonlyMode"></ejs-maskedtextbox>
                    <div class="alert alert-danger"
                      *ngIf="alternateContactForm.get('ACHomePhone').errors  && (alternateContactForm.get('ACHomePhone').dirty || alternateContactForm.get('ACHomePhone').touched)">
                      <span *ngIf="alternateContactForm.get('ACHomePhone').errors.required">Home Phone is required</span>
                      <span *ngIf="alternateContactForm.get('ACHomePhone').errors.lessThanTen">Enter 10 digit Home Phone
                        Number</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 ">
                <div class="form-group">
                  <div class="phone_code">
                    <label>Work Phone
                      <span isMandatory [fieldName]="'ACWorkPhone'" [RequiredList]="alternateContactReqList"
                        class="required">*</span>
                    </label>
                    <select class="form-select" formControlName="ACWorkDialInCode" appHighlightCallScriptFields
                      [fieldName]="'ACWorkDialInCode'" [linkedFieldsList]="altContactCallScriptFields"
                      (mousedown)="readonlyMode && $event.preventDefault()" (keydown)="readonlyMode && $event.preventDefault()"
                      [class.readonly-select]="readonlyMode">
                      <option value="" selected hidden>Select</option>
                      <option *ngFor="let ct of countryList" [value]="ct.Id">
                        {{ct.DialInCode}}</option>
                    </select>
                  </div>
                  <div class="wrk_field">
                    <label>&nbsp;</label>
                    <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputACWorkPhone"
                      formControlName="ACWorkPhone" cssClass="form-control p-0" (focus)="onStartfocus($event)"
                      appHighlightCallScriptFields [fieldName]="'ACWorkPhone'"
                      [linkedFieldsList]="altContactCallScriptFields"
                      (mousedown)="readonlyMode && $event.preventDefault()" (keydown)="readonlyMode && $event.preventDefault()"
                      [class.readonly-select]="readonlyMode"></ejs-maskedtextbox>
                    <div class="alert alert-danger"
                      *ngIf="alternateContactForm.get('ACWorkPhone').errors  && (alternateContactForm.get('ACWorkPhone').dirty || alternateContactForm.get('ACWorkPhone').touched)">
                      <span *ngIf="alternateContactForm.get('ACWorkPhone').errors.required">Workphone is required</span>
                      <span *ngIf="alternateContactForm.get('ACWorkPhone').errors.lessThanTen">Enter 10 digit Workphone
                        Number</span>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4 ">
                <label>Email
                  <span isMandatory [fieldName]="'ACEmail'" [RequiredList]="alternateContactReqList"
                    class="required">*</span>
                </label>
                <input type="text" class="form-control" formControlName="ACEmail" maxlength="50"
                  (keypress)="restrictSpace($event)" appHighlightCallScriptFields [fieldName]="'ACEmail'"
                  [linkedFieldsList]="altContactCallScriptFields" 
                  [readonly]="readonlyMode"
                  (mousedown)="readonlyMode && $event.preventDefault()" (keydown)="readonlyMode && $event.preventDefault()"
                  [class.readonly-select]="readonlyMode"/>
                <div class="alert alert-danger"
                  *ngIf="alternateContactForm.get('ACEmail').errors  && (alternateContactForm.get('ACEmail').dirty || alternateContactForm.get('ACEmail').touched)">
                  <span *ngIf="alternateContactForm.get('ACEmail').errors.pattern" i18n="@@Valid_E-mail"> Enter Valid
                    E-Mail Ids separated by comma or semi colon</span>
                  <span *ngIf="alternateContactForm.get('ACEmail').errors.required">Email is required</span>

                </div>
              </div>
              <div class="col-md-4 ">
                <label>Fax
                  <span isMandatory [fieldName]="'ACFax'" [RequiredList]="alternateContactReqList"
                    class="required">*</span>
                </label>
                <div class="form-group mb-0">
                  <div class="phone_code">
                    <select class="form-select" formControlName="ACFaxDialInCode" appHighlightCallScriptFields
                      [fieldName]="'ACFaxDialInCode'" [linkedFieldsList]="altContactCallScriptFields"
                      (mousedown)="readonlyMode && $event.preventDefault()" (keydown)="readonlyMode && $event.preventDefault()"
                      [class.readonly-select]="readonlyMode">
                      <option value="" selected hidden>Select</option>
                      <option *ngFor="let ct of countryList" [value]="ct.Id">
                        {{ct.DialInCode}}</option>
                    </select>
                  </div>
                  <div class="homephone_numb_field">
                    <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputACFax" formControlName="ACFax"
                      cssClass="form-control p-0" (focus)="onStartfocus($event)" appHighlightCallScriptFields
                      [fieldName]="'ACFax'" [linkedFieldsList]="altContactCallScriptFields"
                      (mousedown)="readonlyMode && $event.preventDefault()" (keydown)="readonlyMode && $event.preventDefault()"
                       [class.readonly-select]="readonlyMode"></ejs-maskedtextbox>
                    <div class="alert alert-danger"
                      *ngIf="alternateContactForm.get('ACFax').errors  && (alternateContactForm.get('ACFax').dirty || alternateContactForm.get('ACFax').touched)">
                      <span *ngIf="alternateContactForm.get('ACFax').errors.required">Fax is required</span>
                      <span *ngIf="alternateContactForm.get('ACFax').errors.lessThanTen">Enter 10 digit Fax
                        Number</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 d-inline-flex pt-3 pt-md-0">
                <div class="me-3">
                  <label class="d-none d-sm-none d-md-block  w-100">&nbsp;</label>
                  <label class="pure-material-checkbox">
                    <input type="checkbox" name="business" formControlName="SendLetters"
                      (click)="!readonlyMode && onClickSendLetters($event)" appHighlightCallScriptFields [fieldName]="'Sendletters'"
                      [linkedFieldsList]="altContactCallScriptFields">
                    <span>Send letters</span>
                  </label>
                </div>
                <div *ngIf="this.alternateContactForm.value.CheckAlternateContact == 'true'">
                  <label class="d-none d-sm-none d-md-block  w-100">&nbsp;</label>
                  <label class="pure-material-checkbox">
                    <input type="checkbox" name="business" (change)="validatePrimaryContact($event)" (click)="!readonlyMode"
                      formControlName="IsPrimaryAlternateContact" appHighlightCallScriptFields
                      [fieldName]="'IsPrimaryAlternateContact'" [linkedFieldsList]="altContactCallScriptFields">
                    <span>Primary Alternate Contact</span>
                  </label>
                </div>
                <div>
                  <label class="d-none d-sm-none d-md-block  w-100">&nbsp;</label>
                  <label class="pure-material-checkbox">
                    <input type="checkbox" name="business" formControlName = "IsEmergencyContact" (click)="!readonlyMode && onClickEmergencyContact($event)">
                    <span>Emergency Contact</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0 mt-4">
            <div class="form-group align-items-center mb-2">
              <label class="pure-material-checkbox">
                <input type="checkbox" name="business" formControlName="GateAccess"
                  (click)="!readonlyMode && enableGateFields($event.target.checked, 0, 0)" appHighlightCallScriptFields
                  [fieldName]="'GateAccess'" [linkedFieldsList]="altContactCallScriptFields">
                <span>Gate Access</span>
              </label>
            </div>
          </div>
          <div class="card p-3 bg-light">
            <div class="row">
              <div class="form-group col-md-4 ">
                <label>Gate Code<span class="required" *ngIf="gateAccessCheckedManually">*</span></label>
                <input type="text" class="form-control" formControlName="ACGateCode" [maxlength]="gateAccessMaxLength"
                  (keypress)="onlyNumberKey($event)" (keyup)="codeChangeSubject.next($event)" (paste)="onPaste($event)"
                  appHighlightCallScriptFields [fieldName]="'ACGateCode'"
                  [linkedFieldsList]="altContactCallScriptFields" [readonly]="readonlyMode"/>
                <div class="alert alert-danger"
                  *ngIf=" alternateContactForm.get('ACGateCode').errors  && (alternateContactForm.get('ACGateCode').dirty || alternateContactForm.get('ACGateCode').touched)">
                  <span *ngIf="alternateContactForm.get('ACGateCode').errors.required">Gate Code is required</span>
                  <span *ngIf="alternateContactForm.get('ACGateCode').errors.whitespace">
                    Invalid input </span>
                  <span *ngIf="alternateContactForm.get('ACGateCode').errors.minlength">
                    Gate Code must be at least {{gateAccessMinLength}} characters long
                  </span>
                  <span *ngIf="alternateContactForm.get('ACGateCode').errors.maxlength">
                    Gate Code can not be more than {{gateAccessMaxLength}} characters long
                  </span>
                </div>
                <div class="alert alert-danger" *ngIf="isGateCodeExist == 1">
                  <span *ngIf="isGateCodeExist == 1">
                    Gate Code {{alternateContactForm.value.ACGateCode}} already exists</span>
                </div>

              </div>

              <div class="form-group col-md-4 ">
                <label>Time Zone<span class="required" *ngIf="gateAccessCheckedManually">*</span></label>
                <select class="form-select" formControlName="ACTimeZone" appHighlightCallScriptFields
                  [fieldName]="'ACTimeZone'" [linkedFieldsList]="altContactCallScriptFields"   
                  (click)="!readonlyMode"
                  [class.readonly-select]="readonlyMode">
                  <option *ngIf="!readonlyMode" value="" selected>Select</option>
                  <option *ngFor="let tz of timeZoneList" [value]="tz.TimeZoneId">
                    {{tz.TimeZoneDescription}}
                  </option>
                </select>
                <div class="alert alert-danger"
                  *ngIf="alternateContactForm.get('ACTimeZone').errors  && (alternateContactForm.get('ACTimeZone').dirty || alternateContactForm.get('ACTimeZone').touched)">
                  <span *ngIf="alternateContactForm.get('ACTimeZone').errors.required">Time
                    Zone
                    is required</span>
                </div>
              </div>
              <div class="form-group col-md-4 ">
                <label>Keypad Zone<span class="required" *ngIf="gateAccessCheckedManually" >*</span></label>
                <select class="form-select" formControlName="ACKeypadZone" appHighlightCallScriptFields
                  [fieldName]="'ACKeypadZone'" [linkedFieldsList]="altContactCallScriptFields" (click)="!readonlyMode"
                  [class.readonly-select]="readonlyMode">
                  <option *ngIf="!readonlyMode" value="" selected>Select</option>
                  <option *ngFor="let kz of keypadZoneList" [value]="kz.KeypadZoneId">
                    {{kz.KeyPadDescription}}
                  </option>
                </select>
                <div class="alert alert-danger"
                  *ngIf="alternateContactForm.get('ACKeypadZone').errors  && (alternateContactForm.get('ACKeypadZone').dirty || alternateContactForm.get('ACKeypadZone').touched)">
                  <span *ngIf="alternateContactForm.get('ACKeypadZone').errors.required">Keypad
                    Zone
                    is required</span>

                </div>
              </div>
            </div>
          </div>

        </form>
      </div>

      <div class="modal-footer">
        <div *ngIf="isEdit">
          <button *ngIf="!readonlyMode" type="button" class="btn btn-primary me-3" data-dismiss="modal" (click)="deleteModal(template2)"
            i18n="@@Delete">Delete</button>
        </div>
        <button *ngIf="!readonlyMode" type="button" class="btn btn-outline-primary me-3" (click)="cancelACForm(template1)">Cancel</button>
        <button *ngIf="!readonlyMode" type="button" class="btn btn-primary" data-dismiss="modal" [disabled]="disableSave()"
          (click)="onACSave()">Save</button>
      </div>
    </div>
  </div>
</div>


<ng-template #template1>
  <div class="modal-header">
    <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body ptb24">
    <p class="mb-0" i18n="@@sureCancel">
      Are you sure you want to cancel? Any data modifications will not be saved.
    </p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-primary me-3" type="button" (click)="reopenOnNotCancel()" i18n="@@No">No</button>
    <button class="btn btn-primary" type="button" (click)="onCancelAC()" i18n="@@Yes">Yes</button>
  </div>
</ng-template>

<ng-template #template2>
  <div class="modal-header">
    <h5 class="modal-title">Delete Alternate Contact</h5>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body ptb24">
    <p class="mb-0" i18n="@@sure_delete_district">Are you sure you want to delete the Alternate Contact?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary me-3" (click)="modalRef.hide()" i18n="@@no">No</button>
    <button type="button" class="btn btn-primary" (click)="deleteAlternateContact()" data-dismiss="modal"
      i18n="@@yes">Yes</button>
  </div>
</ng-template>


<ng-template #primaryValidationTemplate>
  <div class="modal-header">
    <h5 class="modal-title">Notification</h5>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closePrimaryvalidation();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body ptb24">
    <p class="mb-0" i18n="@@sure_delete_district">Checking this will uncheck existing Primary Alternate Contact if any!
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="makePrimaryContact(true)" data-dismiss="modal"
      i18n="@@yes">Ok</button>
  </div>
</ng-template>
